import { FancyButton } from '../../../components/primitives/FancyButton';
import { AdminApi } from '../../../api/models/m2mApi';
import { promptSyncCatalogAsset } from '../actions/m2mCrudOrganization';
import { TpOrganizationInfo } from '../../../api/models/admin';
import { useAppDispatch, useUser } from '../../../app/hooks';
import { addPollingConfiguration, PollingConfiguration } from '../../../data/pollingSlice';
import { addNewTaskExecution } from '../../../data/taskExecutionSlice';
import { promptConfirmationBox, TpConfirmData } from '../../../components/message-boxes/ConfirmBox';
import { taskExecutionPollingId } from '../../../data/pollingService';
import { useNavigate } from 'react-router-dom';

interface TpSyncCatalogButtonProps {
  organization: TpOrganizationInfo;
  adminApi: AdminApi;
}

const SyncCatalogButton = ({ organization, adminApi }: TpSyncCatalogButtonProps) => {
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const navigate = useNavigate();

  const handleSyncCatalogAction = () => {
    return promptSyncCatalogAsset(adminApi, organization, user).then((taskExecution) => {
      const confirmData: TpConfirmData = {
        title: `Your Catalog Asset Sync has just started`,
        description: `Would you like to proceed to the 'Task Executions' page? \n\n`,
        cancelButtonLabel: `Close`,
      };
      if (taskExecution) {
        const pollingConfig: PollingConfiguration = {
          identifier: taskExecutionPollingId,
          interval: 15000,
        };
        dispatch(addNewTaskExecution({ taskExecution }));
        dispatch(addPollingConfiguration(pollingConfig));
      }

      return promptConfirmationBox(confirmData).then((confirmed) => {
        if (confirmed) {
          navigate(`/task-executions`);
        }
      });
    });
  };

  return (
    <FancyButton iconName="fas:folder-tree" onClick={handleSyncCatalogAction}>
      Sync Catalog Asset
    </FancyButton>
  );
};

export default SyncCatalogButton;
